import { ETourId, type ITourConfig } from '../types';

/**
 * Tour shown when the user first visits the automations list dashboard.
 *
 * Four steps orienting the user around the page:
 * 1. Monitor automations — the Automations sidebar nav item
 * 2. See trends over time — the runs insight graph
 * 3. Track what matters — the insight metric cards
 * 4. Monitor individual automations — the automation cards grid
 */
export const automationListDashboardTour: ITourConfig = {
  id: ETourId.AUTOMATION_LIST_DASHBOARD,
  steps: [
    {
      id: 'runs-graph-highlight',
      target: '[data-tour-id="automations-runs-graph"]',
      titleKey: 'tours.automationListDashboard.runsGraphHighlight.title',
      descriptionKey:
        'tours.automationListDashboard.runsGraphHighlight.description',
      position: 'bottomLeft',
    },
    {
      id: 'insights-highlight',
      target: '[data-tour-id="automations-insights"]',
      titleKey: 'tours.automationListDashboard.insightsHighlight.title',
      descriptionKey:
        'tours.automationListDashboard.insightsHighlight.description',
      position: 'topLeft',
    },
    {
      id: 'automations-grid-highlight',
      target: '[data-tour-id="automations-first-card"]',
      titleKey: 'tours.automationListDashboard.automationsGridHighlight.title',
      descriptionKey:
        'tours.automationListDashboard.automationsGridHighlight.description',
      finishLabelKey:
        'tours.automationListDashboard.automationsGridHighlight.finishLabel',
      position: 'topLeft',
    },
    {
      id: 'guidance-center-sidebar-highlight',
      target: '[data-tour-id="sidebar-guidance-center-tab"]',
      titleKey:
        'tours.automationListDashboard.guidanceCenterSidebarHighlight.title',
      descriptionKey:
        'tours.automationListDashboard.guidanceCenterSidebarHighlight.description',
      finishLabelKey:
        'tours.automationListDashboard.guidanceCenterSidebarHighlight.finishLabel',
      position: 'rightTop',
    },
  ],
  namespace: 'tours',
  variant: 'default',
  size: 'sm',
  analytics: {
    enabled: true,
    eventPrefix: 'tour_automation_list_dashboard',
    metadata: {
      tourName: 'Automation List Dashboard',
    },
  },
  persistence: {
    strategy: 'localStorage',
  },
};
